// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from "./client";
import { client } from "./client.gen";
import {
  createKnowledgeBaseResponseTransformer,
  getKnowledgeBaseResponseTransformer,
  getWorkflowResponseTransformer,
  getWorkflowsResponseTransformer,
  listKnowledgeBaseFilesResponseTransformer,
  queryActionsForNodeResponseTransformer,
  updateKnowledgeBaseResponseTransformer,
} from "./transformers.gen";
import type {
  AddEdgesData,
  AddEdgesErrors,
  AddEdgesResponses,
  AddNodesData,
  AddNodesErrors,
  AddNodesResponses,
  CancelWorkflowData,
  CancelWorkflowErrors,
  CancelWorkflowResponses,
  CopilotQueryStreamData,
  CopilotQueryStreamErrors,
  CopilotQueryStreamResponses,
  CopyGraphData,
  CopyGraphErrors,
  CopyGraphResponses,
  CreateAgentData,
  CreateAgentErrors,
  CreateAgentResponses,
  CreateApiKeyData,
  CreateApiKeyErrors,
  CreateApiKeyResponses,
  CreateConversationData,
  CreateConversationErrors,
  CreateConversationResponses,
  CreateEntityClassData,
  CreateEntityClassErrors,
  CreateEntityClassResponses,
  CreateEntityData,
  CreateEntityErrors,
  CreateEntityResponses,
  CreateGraphData,
  CreateGraphErrors,
  CreateGraphResponses,
  CreateIntegrationData,
  CreateIntegrationErrors,
  CreateIntegrationResponses,
  CreateKnowledgeBaseData,
  CreateKnowledgeBaseErrors,
  CreateKnowledgeBaseResponses,
  CreateNotificationProviderData,
  CreateNotificationProviderErrors,
  CreateNotificationProviderResponses,
  CreatePollerData,
  CreatePollerErrors,
  CreatePollerResponses,
  CreateQueryActionData,
  CreateQueryActionErrors,
  CreateQueryActionResponses,
  CreateUserData,
  CreateUserErrors,
  CreateUserResponses,
  CreateWorkflowOrLocalActionData,
  CreateWorkflowOrLocalActionResponses,
  DeleteAgentData,
  DeleteAgentErrors,
  DeleteAgentResponses,
  DeleteApiKeyData,
  DeleteApiKeyErrors,
  DeleteApiKeyResponses,
  DeleteElementsData,
  DeleteElementsErrors,
  DeleteElementsResponses,
  DeleteEntityClassData,
  DeleteEntityClassErrors,
  DeleteEntityClassResponses,
  DeleteEntityData,
  DeleteEntityErrors,
  DeleteEntityResponses,
  DeleteGraphData,
  DeleteGraphErrors,
  DeleteGraphResponses,
  DeleteIntegrationData,
  DeleteIntegrationErrors,
  DeleteIntegrationResponses,
  DeleteKnowledgeBaseData,
  DeleteKnowledgeBaseErrors,
  DeleteKnowledgeBaseFileData,
  DeleteKnowledgeBaseFileErrors,
  DeleteKnowledgeBaseFileResponses,
  DeleteKnowledgeBaseResponses,
  DeleteNotificationProviderData,
  DeleteNotificationProviderErrors,
  DeleteNotificationProviderResponses,
  DeletePollerData,
  DeletePollerErrors,
  DeletePollerResponses,
  DeleteQueryActionData,
  DeleteQueryActionErrors,
  DeleteQueryActionResponses,
  DeleteUserData,
  DeleteUserErrors,
  DeleteUserResponses,
  ExecuteSavedQueryActionData,
  ExecuteSavedQueryActionErrors,
  ExecuteSavedQueryActionResponses,
  GenerateLiquidTemplateData,
  GenerateLiquidTemplateErrors,
  GenerateLiquidTemplateResponses,
  GetAgentData,
  GetAgentErrors,
  GetAgentResponses,
  GetConversationData,
  GetConversationErrors,
  GetConversationResponses,
  GetDocsYmlData,
  GetDocsYmlResponses,
  GetEntityByQualifiedNameData,
  GetEntityByQualifiedNameErrors,
  GetEntityByQualifiedNameResponses,
  GetEntityClassData,
  GetEntityClassErrors,
  GetEntityClassResponses,
  GetEntityData,
  GetEntityErrors,
  GetEntityResponses,
  GetEventData,
  GetEventErrors,
  GetEventResponses,
  GetGraphData,
  GetGraphDetailsData,
  GetGraphDetailsErrors,
  GetGraphDetailsResponses,
  GetGraphErrors,
  GetGraphResponses,
  GetIntegrationData,
  GetIntegrationErrors,
  GetIntegrationResponses,
  GetKnowledgeBaseData,
  GetKnowledgeBaseErrors,
  GetKnowledgeBaseResponses,
  GetNotificationProviderData,
  GetNotificationProviderErrors,
  GetNotificationProviderResponses,
  GetPollerData,
  GetPollerErrors,
  GetPollerResponses,
  GetQueryActionData,
  GetQueryActionErrors,
  GetQueryActionResponses,
  GetSessionListData,
  GetSessionListErrors,
  GetSessionListResponses,
  GetWorkflowData,
  GetWorkflowErrors,
  GetWorkflowRawDataData,
  GetWorkflowRawDataErrors,
  GetWorkflowRawDataResponses,
  GetWorkflowResponses,
  GetWorkflowsData,
  GetWorkflowsErrors,
  GetWorkflowsResponses,
  GetWorkflowsStreamData,
  GetWorkflowsStreamErrors,
  GetWorkflowsStreamResponses,
  HydrateToolData,
  HydrateToolErrors,
  HydrateToolResponses,
  ListAgentsData,
  ListAgentsResponses,
  ListApiKeysData,
  ListApiKeysResponses,
  ListEntitiesShortnamesData,
  ListEntitiesShortnamesErrors,
  ListEntitiesShortnamesResponses,
  ListEntityClassesData,
  ListEntityClassesResponses,
  ListEventsData,
  ListEventsResponses,
  ListGraphsData,
  ListGraphsResponses,
  ListIntegrationsData,
  ListIntegrationsErrors,
  ListIntegrationsResponses,
  ListKnowledgeBaseFilesData,
  ListKnowledgeBaseFilesErrors,
  ListKnowledgeBaseFilesResponses,
  ListKnowledgeBasesData,
  ListKnowledgeBasesResponses,
  ListMcpToolsByWebhookData,
  ListMcpToolsByWebhookErrors,
  ListMcpToolsByWebhookResponses,
  ListMcpToolsData,
  ListMcpToolsErrors,
  ListMcpToolsJsonRpcData,
  ListMcpToolsJsonRpcErrors,
  ListMcpToolsJsonRpcResponses,
  ListMcpToolsResponses,
  ListNotificationProvidersData,
  ListNotificationProvidersErrors,
  ListNotificationProvidersResponses,
  ListPollersData,
  ListPollersResponses,
  ListQueryActionData,
  ListQueryActionErrors,
  ListQueryActionResponses,
  ListTopEntitiesData,
  ListTopEntitiesErrors,
  ListTopEntitiesResponses,
  ListUsersData,
  ListUsersResponses,
  PostKnowledgeBasesByIdFilesData,
  PostKnowledgeBasesByIdFilesErrors,
  PostKnowledgeBasesByIdFilesResponses,
  PostWorkspacesByIdUploadData,
  PostWorkspacesByIdUploadErrors,
  PostWorkspacesByIdUploadResponses,
  QueryActionsForNodeData,
  QueryActionsForNodeErrors,
  QueryActionsForNodeResponses,
  ReceiveWebhookData,
  ReceiveWebhookErrors,
  ReceiveWebhookResponses,
  SearchAgentsData,
  SearchAgentsErrors,
  SearchAgentsResponses,
  SearchEntitiesData,
  SearchEntitiesErrors,
  SearchEntitiesResponses,
  SearchEventsData,
  SearchEventsErrors,
  SearchEventsResponses,
  SearchGraphsData,
  SearchGraphsErrors,
  SearchGraphsResponses,
  SearchNotificationProvidersData,
  SearchNotificationProvidersErrors,
  SearchNotificationProvidersResponses,
  SearchPollersData,
  SearchPollersErrors,
  SearchPollersResponses,
  SearchQueryActionsData,
  SearchQueryActionsErrors,
  SearchQueryActionsResponses,
  TestQueryActionData,
  TestQueryActionErrors,
  TestQueryActionResponses,
  TriggerAgentData,
  TriggerAgentErrors,
  TriggerAgentResponses,
  UpdateAgentData,
  UpdateAgentErrors,
  UpdateAgentResponses,
  UpdateApiKeyData,
  UpdateApiKeyErrors,
  UpdateApiKeyResponses,
  UpdateEdgesData,
  UpdateEdgesErrors,
  UpdateEdgesResponses,
  UpdateEntityClassData,
  UpdateEntityClassErrors,
  UpdateEntityClassResponses,
  UpdateEntityData,
  UpdateEntityErrors,
  UpdateEntityResponses,
  UpdateGraphData,
  UpdateGraphErrors,
  UpdateGraphResponses,
  UpdateIntegrationData,
  UpdateIntegrationErrors,
  UpdateIntegrationResponses,
  UpdateKnowledgeBaseData,
  UpdateKnowledgeBaseErrors,
  UpdateKnowledgeBaseResponses,
  UpdateNodePositionsData,
  UpdateNodePositionsErrors,
  UpdateNodePositionsResponses,
  UpdateNodesData,
  UpdateNodesErrors,
  UpdateNodesResponses,
  UpdateNotificationProviderData,
  UpdateNotificationProviderErrors,
  UpdateNotificationProviderResponses,
  UpdatePollerData,
  UpdatePollerErrors,
  UpdatePollerResponses,
  UpdateQueryActionData,
  UpdateQueryActionErrors,
  UpdateQueryActionResponses,
  UpdateUserData,
  UpdateUserErrors,
  UpdateUserResponses,
} from "./types.gen";

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
> = Options2<TData, ThrowOnError> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

export const getDocsYml = <ThrowOnError extends boolean = false>(
  options?: Options<GetDocsYmlData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetDocsYmlResponses, unknown, ThrowOnError>({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/docs/yml",
    ...options,
  });

/**
 * List available MCP tools
 *
 * Get the list of available tools in MCP format
 */
export const listMcpTools = <ThrowOnError extends boolean = false>(
  options?: Options<ListMcpToolsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListMcpToolsResponses,
    ListMcpToolsErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/mcp/tools",
    ...options,
  });

/**
 * List MCP tools with JSON-RPC envelope
 *
 * Get the same tools list wrapped in JSON-RPC format
 */
export const listMcpToolsJsonRpc = <ThrowOnError extends boolean = false>(
  options?: Options<ListMcpToolsJsonRpcData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListMcpToolsJsonRpcResponses,
    ListMcpToolsJsonRpcErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/mcp/tools.jsonrpc",
    ...options,
  });

/**
 * List MCP tools filtered by webhook
 *
 * Only include tools mapped in the alert source toolMappings
 */
export const listMcpToolsByWebhook = <ThrowOnError extends boolean = false>(
  options: Options<ListMcpToolsByWebhookData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ListMcpToolsByWebhookResponses,
    ListMcpToolsByWebhookErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/mcp/tools/{webhookId}",
    ...options,
  });

/**
 * Hydrate a specific MCP tool
 *
 * Generate EnrichWorkflowInputArgs for the specified tool ID with provided parameter values
 */
export const hydrateTool = <ThrowOnError extends boolean = false>(
  options: Options<HydrateToolData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    HydrateToolResponses,
    HydrateToolErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/mcp/tools/{toolId}/hydrate",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List Agents
 */
export const listAgents = <ThrowOnError extends boolean = false>(
  options?: Options<ListAgentsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListAgentsResponses, unknown, ThrowOnError>({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/agents",
    ...options,
  });

/**
 * Create a new Agent
 */
export const createAgent = <ThrowOnError extends boolean = false>(
  options: Options<CreateAgentData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateAgentResponses,
    CreateAgentErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/agents",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete an Agent
 */
export const deleteAgent = <ThrowOnError extends boolean = false>(
  options: Options<DeleteAgentData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAgentResponses,
    DeleteAgentErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/agents/{id}",
    ...options,
  });

/**
 * Get an Agent
 */
export const getAgent = <ThrowOnError extends boolean = false>(
  options: Options<GetAgentData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAgentResponses,
    GetAgentErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/agents/{id}",
    ...options,
  });

/**
 * Update an Agent
 */
export const updateAgent = <ThrowOnError extends boolean = false>(
  options: Options<UpdateAgentData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    UpdateAgentResponses,
    UpdateAgentErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/agents/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Search agents by name
 *
 * Performs a case-insensitive search across agent names
 */
export const searchAgents = <ThrowOnError extends boolean = false>(
  options: Options<SearchAgentsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    SearchAgentsResponses,
    SearchAgentsErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/agents/search",
    ...options,
  });

/**
 * Create a new Entity Class
 */
export const createEntity = <ThrowOnError extends boolean = false>(
  options?: Options<CreateEntityData, ThrowOnError>,
) =>
  (options?.client ?? client).post<
    CreateEntityResponses,
    CreateEntityErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/entities",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });

/**
 * Delete an entity
 *
 * Deletes an entity by its ID
 */
export const deleteEntity = <ThrowOnError extends boolean = false>(
  options: Options<DeleteEntityData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteEntityResponses,
    DeleteEntityErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/entities/{entityId}",
    ...options,
  });

/**
 * Get an entity by ID
 *
 * Retrieves an entity by its ID
 */
export const getEntity = <ThrowOnError extends boolean = false>(
  options: Options<GetEntityData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetEntityResponses,
    GetEntityErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/entities/{entityId}",
    ...options,
  });

/**
 * Update an entity
 *
 * Updates an entity by its ID
 */
export const updateEntity = <ThrowOnError extends boolean = false>(
  options: Options<UpdateEntityData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    UpdateEntityResponses,
    UpdateEntityErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/entities/{entityId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get an entity by qualifiedName
 *
 * Retrieves an entity by its qualified name
 */
export const getEntityByQualifiedName = <ThrowOnError extends boolean = false>(
  options: Options<GetEntityByQualifiedNameData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetEntityByQualifiedNameResponses,
    GetEntityByQualifiedNameErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/entities/by-qualified-name/{qualifiedName}",
    ...options,
  });

/**
 * List top entities by connection count across all classes
 *
 * Returns the top entities sorted by number of connections (entityMappings + inputMappings)
 */
export const listTopEntities = <ThrowOnError extends boolean = false>(
  options?: Options<ListTopEntitiesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListTopEntitiesResponses,
    ListTopEntitiesErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/entities/top",
    ...options,
  });

/**
 * List Entity Shortnames
 */
export const listEntitiesShortnames = <ThrowOnError extends boolean = false>(
  options?: Options<ListEntitiesShortnamesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListEntitiesShortnamesResponses,
    ListEntitiesShortnamesErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/entities-shortlist",
    ...options,
  });

/**
 * Search entities by name, qualifiedName, or description
 *
 * Performs a fuzzy search across entity fields
 */
export const searchEntities = <ThrowOnError extends boolean = false>(
  options: Options<SearchEntitiesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    SearchEntitiesResponses,
    SearchEntitiesErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/entities/search",
    ...options,
  });

/**
 * Query Copilot with streaming response (Server-Sent Events)
 */
export const copilotQueryStream = <ThrowOnError extends boolean = false>(
  options: Options<CopilotQueryStreamData, ThrowOnError>,
) =>
  (options.client ?? client).sse.post<
    CopilotQueryStreamResponses,
    CopilotQueryStreamErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/copilot/query",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Start a new copilot conversation
 */
export const createConversation = <ThrowOnError extends boolean = false>(
  options?: Options<CreateConversationData, ThrowOnError>,
) =>
  (options?.client ?? client).post<
    CreateConversationResponses,
    CreateConversationErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/copilot/create-conversation",
    ...options,
  });

/**
 * Get the conversation for a given session id
 */
export const getConversation = <ThrowOnError extends boolean = false>(
  options: Options<GetConversationData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    GetConversationResponses,
    GetConversationErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/copilot/get-conversation",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get the session list for a given user
 */
export const getSessionList = <ThrowOnError extends boolean = false>(
  options?: Options<GetSessionListData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetSessionListResponses,
    GetSessionListErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/copilot/get-sessions",
    ...options,
  });

/**
 * Generate a Liquid template from a user description and JSON context
 */
export const generateLiquidTemplate = <ThrowOnError extends boolean = false>(
  options: Options<GenerateLiquidTemplateData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    GenerateLiquidTemplateResponses,
    GenerateLiquidTemplateErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/copilot/generate-liquid-template",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get an Event
 */
export const getEvent = <ThrowOnError extends boolean = false>(
  options: Options<GetEventData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetEventResponses,
    GetEventErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/events/{id}",
    ...options,
  });

/**
 * List Events
 */
export const listEvents = <ThrowOnError extends boolean = false>(
  options?: Options<ListEventsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListEventsResponses, unknown, ThrowOnError>({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/events",
    ...options,
  });

/**
 * Cancel a Workflow
 */
export const cancelWorkflow = <ThrowOnError extends boolean = false>(
  options: Options<CancelWorkflowData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    CancelWorkflowResponses,
    CancelWorkflowErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/events/{id}/cancel",
    ...options,
  });

/**
 * Search Events by name
 *
 * Performs a case-insensitive search across Event names
 */
export const searchEvents = <ThrowOnError extends boolean = false>(
  options: Options<SearchEventsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    SearchEventsResponses,
    SearchEventsErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/events/search",
    ...options,
  });

/**
 * List Entity Classes
 */
export const listEntityClasses = <ThrowOnError extends boolean = false>(
  options?: Options<ListEntityClassesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListEntityClassesResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/entity-classes",
    ...options,
  });

/**
 * Create a new Entity Class
 */
export const createEntityClass = <ThrowOnError extends boolean = false>(
  options?: Options<CreateEntityClassData, ThrowOnError>,
) =>
  (options?.client ?? client).post<
    CreateEntityClassResponses,
    CreateEntityClassErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/entity-classes",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });

/**
 * Delete an Entity Class
 */
export const deleteEntityClass = <ThrowOnError extends boolean = false>(
  options: Options<DeleteEntityClassData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteEntityClassResponses,
    DeleteEntityClassErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/entity-classes/{id}",
    ...options,
  });

/**
 * Get an Entity Class
 */
export const getEntityClass = <ThrowOnError extends boolean = false>(
  options: Options<GetEntityClassData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetEntityClassResponses,
    GetEntityClassErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/entity-classes/{id}",
    ...options,
  });

/**
 * Update an Entity Class
 */
export const updateEntityClass = <ThrowOnError extends boolean = false>(
  options: Options<UpdateEntityClassData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    UpdateEntityClassResponses,
    UpdateEntityClassErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/entity-classes/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List Knowledge Bases
 *
 * Get paginated list of all knowledge bases
 */
export const listKnowledgeBases = <ThrowOnError extends boolean = false>(
  options?: Options<ListKnowledgeBasesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListKnowledgeBasesResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/knowledge-bases",
    ...options,
  });

/**
 * Create a new Knowledge Base
 */
export const createKnowledgeBase = <ThrowOnError extends boolean = false>(
  options: Options<CreateKnowledgeBaseData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateKnowledgeBaseResponses,
    CreateKnowledgeBaseErrors,
    ThrowOnError
  >({
    responseTransformer: createKnowledgeBaseResponseTransformer,
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/knowledge-bases",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete a Knowledge Base
 */
export const deleteKnowledgeBase = <ThrowOnError extends boolean = false>(
  options: Options<DeleteKnowledgeBaseData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteKnowledgeBaseResponses,
    DeleteKnowledgeBaseErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/knowledge-bases/{id}",
    ...options,
  });

/**
 * Get a Knowledge Base by ID
 */
export const getKnowledgeBase = <ThrowOnError extends boolean = false>(
  options: Options<GetKnowledgeBaseData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetKnowledgeBaseResponses,
    GetKnowledgeBaseErrors,
    ThrowOnError
  >({
    responseTransformer: getKnowledgeBaseResponseTransformer,
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/knowledge-bases/{id}",
    ...options,
  });

/**
 * Update a Knowledge Base
 */
export const updateKnowledgeBase = <ThrowOnError extends boolean = false>(
  options: Options<UpdateKnowledgeBaseData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    UpdateKnowledgeBaseResponses,
    UpdateKnowledgeBaseErrors,
    ThrowOnError
  >({
    responseTransformer: updateKnowledgeBaseResponseTransformer,
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/knowledge-bases/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List files in a Knowledge Base
 *
 * Get all files uploaded to a knowledge base
 */
export const listKnowledgeBaseFiles = <ThrowOnError extends boolean = false>(
  options: Options<ListKnowledgeBaseFilesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ListKnowledgeBaseFilesResponses,
    ListKnowledgeBaseFilesErrors,
    ThrowOnError
  >({
    responseTransformer: listKnowledgeBaseFilesResponseTransformer,
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/knowledge-bases/{id}/files",
    ...options,
  });

export const postKnowledgeBasesByIdFiles = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostKnowledgeBasesByIdFilesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostKnowledgeBasesByIdFilesResponses,
    PostKnowledgeBasesByIdFilesErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/knowledge-bases/{id}/files",
    ...options,
  });

/**
 * Delete a file from a Knowledge Base
 *
 * Delete a file from S3 and database
 */
export const deleteKnowledgeBaseFile = <ThrowOnError extends boolean = false>(
  options: Options<DeleteKnowledgeBaseFileData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteKnowledgeBaseFileResponses,
    DeleteKnowledgeBaseFileErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/knowledge-bases/{id}/files/{fileId}",
    ...options,
  });

/**
 * List ApiKeys
 */
export const listApiKeys = <ThrowOnError extends boolean = false>(
  options?: Options<ListApiKeysData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListApiKeysResponses, unknown, ThrowOnError>({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/api-keys",
    ...options,
  });

/**
 * Create a new ApiKey
 */
export const createApiKey = <ThrowOnError extends boolean = false>(
  options?: Options<CreateApiKeyData, ThrowOnError>,
) =>
  (options?.client ?? client).post<
    CreateApiKeyResponses,
    CreateApiKeyErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/api-keys",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });

/**
 * Delete an ApiKey
 */
export const deleteApiKey = <ThrowOnError extends boolean = false>(
  options: Options<DeleteApiKeyData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteApiKeyResponses,
    DeleteApiKeyErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/api-keys/{id}",
    ...options,
  });

/**
 * Update a ApiKey
 */
export const updateApiKey = <ThrowOnError extends boolean = false>(
  options: Options<UpdateApiKeyData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    UpdateApiKeyResponses,
    UpdateApiKeyErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/api-keys/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List NotificationProviders
 */
export const listNotificationProviders = <ThrowOnError extends boolean = false>(
  options?: Options<ListNotificationProvidersData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListNotificationProvidersResponses,
    ListNotificationProvidersErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/notifications",
    ...options,
  });

/**
 * Create a new NotificationProvider
 */
export const createNotificationProvider = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<CreateNotificationProviderData, ThrowOnError>,
) =>
  (options?.client ?? client).post<
    CreateNotificationProviderResponses,
    CreateNotificationProviderErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/notifications",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });

/**
 * Delete a Notification Provider
 */
export const deleteNotificationProvider = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteNotificationProviderData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteNotificationProviderResponses,
    DeleteNotificationProviderErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/notifications/{id}",
    ...options,
  });

/**
 * Get a Notification Provider
 */
export const getNotificationProvider = <ThrowOnError extends boolean = false>(
  options: Options<GetNotificationProviderData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetNotificationProviderResponses,
    GetNotificationProviderErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/notifications/{id}",
    ...options,
  });

/**
 * Update a Notification Provider
 */
export const updateNotificationProvider = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateNotificationProviderData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    UpdateNotificationProviderResponses,
    UpdateNotificationProviderErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/notifications/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Search Notification Providers
 */
export const searchNotificationProviders = <
  ThrowOnError extends boolean = false,
>(
  options: Options<SearchNotificationProvidersData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    SearchNotificationProvidersResponses,
    SearchNotificationProvidersErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/notifications/search",
    ...options,
  });

/**
 * List Graphs
 */
export const listGraphs = <ThrowOnError extends boolean = false>(
  options?: Options<ListGraphsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListGraphsResponses, unknown, ThrowOnError>({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/workspaces",
    ...options,
  });

/**
 * Create a new Graph
 */
export const createGraph = <ThrowOnError extends boolean = false>(
  options: Options<CreateGraphData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateGraphResponses,
    CreateGraphErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/workspaces",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete a Graph
 */
export const deleteGraph = <ThrowOnError extends boolean = false>(
  options: Options<DeleteGraphData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteGraphResponses,
    DeleteGraphErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/workspaces/{id}",
    ...options,
  });

/**
 * Copy a Graph
 */
export const copyGraph = <ThrowOnError extends boolean = false>(
  options: Options<CopyGraphData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CopyGraphResponses,
    CopyGraphErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/workspaces/{id}/copy",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get a Graph
 */
export const getGraph = <ThrowOnError extends boolean = false>(
  options: Options<GetGraphData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetGraphResponses,
    GetGraphErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/workspaces/{id}/summary",
    ...options,
  });

/**
 * Update a Graph
 */
export const updateGraph = <ThrowOnError extends boolean = false>(
  options: Options<UpdateGraphData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    UpdateGraphResponses,
    UpdateGraphErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/workspaces/{id}/summary",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Search graphs by name
 *
 * Performs a case-insensitive search across graph names
 */
export const searchGraphs = <ThrowOnError extends boolean = false>(
  options: Options<SearchGraphsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    SearchGraphsResponses,
    SearchGraphsErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/workspaces/search",
    ...options,
  });

/**
 * Get graph details
 */
export const getGraphDetails = <ThrowOnError extends boolean = false>(
  options: Options<GetGraphDetailsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetGraphDetailsResponses,
    GetGraphDetailsErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/workspaces/{id}/details",
    ...options,
  });

/**
 * Add edges
 */
export const addEdges = <ThrowOnError extends boolean = false>(
  options: Options<AddEdgesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    AddEdgesResponses,
    AddEdgesErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/workspaces/{id}/edges",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Update edges
 */
export const updateEdges = <ThrowOnError extends boolean = false>(
  options: Options<UpdateEdgesData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    UpdateEdgesResponses,
    UpdateEdgesErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/workspaces/{id}/edges",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete nodes and edges
 */
export const deleteElements = <ThrowOnError extends boolean = false>(
  options: Options<DeleteElementsData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteElementsResponses,
    DeleteElementsErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/workspaces/{id}/elements",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Add nodes
 */
export const addNodes = <ThrowOnError extends boolean = false>(
  options: Options<AddNodesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    AddNodesResponses,
    AddNodesErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/workspaces/{id}/nodes",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Update nodes
 */
export const updateNodes = <ThrowOnError extends boolean = false>(
  options: Options<UpdateNodesData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    UpdateNodesResponses,
    UpdateNodesErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/workspaces/{id}/nodes",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Update node positions
 */
export const updateNodePositions = <ThrowOnError extends boolean = false>(
  options: Options<UpdateNodePositionsData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    UpdateNodePositionsResponses,
    UpdateNodePositionsErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/workspaces/{id}/node-positions",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const postWorkspacesByIdUpload = <ThrowOnError extends boolean = false>(
  options: Options<PostWorkspacesByIdUploadData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostWorkspacesByIdUploadResponses,
    PostWorkspacesByIdUploadErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/workspaces/{id}/upload",
    ...options,
  });

/**
 * List Integrations
 */
export const listIntegrations = <ThrowOnError extends boolean = false>(
  options?: Options<ListIntegrationsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListIntegrationsResponses,
    ListIntegrationsErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/integrations",
    ...options,
  });

/**
 * Create a new Integration
 */
export const createIntegration = <ThrowOnError extends boolean = false>(
  options?: Options<CreateIntegrationData, ThrowOnError>,
) =>
  (options?.client ?? client).post<
    CreateIntegrationResponses,
    CreateIntegrationErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/integrations",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });

/**
 * Delete an Integration
 */
export const deleteIntegration = <ThrowOnError extends boolean = false>(
  options: Options<DeleteIntegrationData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteIntegrationResponses,
    DeleteIntegrationErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/integrations/{id}",
    ...options,
  });

/**
 * Get an Integration
 */
export const getIntegration = <ThrowOnError extends boolean = false>(
  options: Options<GetIntegrationData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetIntegrationResponses,
    GetIntegrationErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/integrations/{id}",
    ...options,
  });

/**
 * Update an Integration
 */
export const updateIntegration = <ThrowOnError extends boolean = false>(
  options: Options<UpdateIntegrationData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    UpdateIntegrationResponses,
    UpdateIntegrationErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/integrations/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List Users
 */
export const listUsers = <ThrowOnError extends boolean = false>(
  options?: Options<ListUsersData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListUsersResponses, unknown, ThrowOnError>({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/users",
    ...options,
  });

/**
 * Create a new User
 */
export const createUser = <ThrowOnError extends boolean = false>(
  options: Options<CreateUserData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateUserResponses,
    CreateUserErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/users",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete a user
 */
export const deleteUser = <ThrowOnError extends boolean = false>(
  options: Options<DeleteUserData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteUserResponses,
    DeleteUserErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/users/{id}",
    ...options,
  });

/**
 * Update a user
 */
export const updateUser = <ThrowOnError extends boolean = false>(
  options: Options<UpdateUserData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    UpdateUserResponses,
    UpdateUserErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/users/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List Pollers
 */
export const listPollers = <ThrowOnError extends boolean = false>(
  options?: Options<ListPollersData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListPollersResponses, unknown, ThrowOnError>({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/pollers",
    ...options,
  });

/**
 * Create a new Poller
 */
export const createPoller = <ThrowOnError extends boolean = false>(
  options: Options<CreatePollerData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreatePollerResponses,
    CreatePollerErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/pollers",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete a Poller
 */
export const deletePoller = <ThrowOnError extends boolean = false>(
  options: Options<DeletePollerData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeletePollerResponses,
    DeletePollerErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/pollers/{id}",
    ...options,
  });

/**
 * Get a Poller
 */
export const getPoller = <ThrowOnError extends boolean = false>(
  options: Options<GetPollerData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetPollerResponses,
    GetPollerErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/pollers/{id}",
    ...options,
  });

/**
 * Update a Poller
 */
export const updatePoller = <ThrowOnError extends boolean = false>(
  options: Options<UpdatePollerData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    UpdatePollerResponses,
    UpdatePollerErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/pollers/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Search pollers by name
 *
 * Performs a case-insensitive search across poller names
 */
export const searchPollers = <ThrowOnError extends boolean = false>(
  options: Options<SearchPollersData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    SearchPollersResponses,
    SearchPollersErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/pollers/search",
    ...options,
  });

/**
 * Execute a saved Query Action
 */
export const executeSavedQueryAction = <ThrowOnError extends boolean = false>(
  options: Options<ExecuteSavedQueryActionData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ExecuteSavedQueryActionResponses,
    ExecuteSavedQueryActionErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/query-actions/{queryActionId}/execute",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Test a new Query Action
 */
export const testQueryAction = <ThrowOnError extends boolean = false>(
  options: Options<TestQueryActionData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    TestQueryActionResponses,
    TestQueryActionErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/query-actions/test",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List Query Actions
 *
 * Optional query parameter integrationId filters results to that integration.
 */
export const listQueryAction = <ThrowOnError extends boolean = false>(
  options?: Options<ListQueryActionData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListQueryActionResponses,
    ListQueryActionErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/query-actions",
    ...options,
  });

/**
 * Create a new Query Action
 */
export const createQueryAction = <ThrowOnError extends boolean = false>(
  options: Options<CreateQueryActionData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateQueryActionResponses,
    CreateQueryActionErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/query-actions",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete a query action
 */
export const deleteQueryAction = <ThrowOnError extends boolean = false>(
  options: Options<DeleteQueryActionData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteQueryActionResponses,
    DeleteQueryActionErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/query-actions/{queryActionId}",
    ...options,
  });

/**
 * Get a query action
 */
export const getQueryAction = <ThrowOnError extends boolean = false>(
  options: Options<GetQueryActionData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetQueryActionResponses,
    GetQueryActionErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/query-actions/{queryActionId}",
    ...options,
  });

/**
 * Update a Query Action
 */
export const updateQueryAction = <ThrowOnError extends boolean = false>(
  options: Options<UpdateQueryActionData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    UpdateQueryActionResponses,
    UpdateQueryActionErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/query-actions/{queryActionId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Search query actions by name, description, or integration details
 *
 * Performs a fuzzy search across query actions and their integrations
 */
export const searchQueryActions = <ThrowOnError extends boolean = false>(
  options: Options<SearchQueryActionsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    SearchQueryActionsResponses,
    SearchQueryActionsErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/query-actions/search",
    ...options,
  });

/**
 * Gets the available query actions for a given node id
 *
 * Given a node id returns the available query action relationships available for that node
 */
export const queryActionsForNode = <ThrowOnError extends boolean = false>(
  options: Options<QueryActionsForNodeData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    QueryActionsForNodeResponses,
    QueryActionsForNodeErrors,
    ThrowOnError
  >({
    responseTransformer: queryActionsForNodeResponseTransformer,
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/query-actions-for/{id}",
    ...options,
  });

/**
 * Receive webhook data
 *
 * Endpoint to receive webhook data from external services. Accepts any JSON payload.
 */
export const receiveWebhook = <ThrowOnError extends boolean = false>(
  options: Options<ReceiveWebhookData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ReceiveWebhookResponses,
    ReceiveWebhookErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/webhook/{webhookId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Trigger agent with custom prompt
 *
 * Endpoint to trigger an agentic workflow with a custom prompt and optional payload data, allowing frontend applications to invoke agents without configuring webhooks.
 */
export const triggerAgent = <ThrowOnError extends boolean = false>(
  options: Options<TriggerAgentData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    TriggerAgentResponses,
    TriggerAgentErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/webhook/trigger/{webhookId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get all workflows with optional filters
 *
 * Get all workflows with optional filters
 */
export const getWorkflows = <ThrowOnError extends boolean = false>(
  options?: Options<GetWorkflowsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetWorkflowsResponses,
    GetWorkflowsErrors,
    ThrowOnError
  >({
    responseTransformer: getWorkflowsResponseTransformer,
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/workflows",
    ...options,
  });

/**
 * Create a workflow or trigger local ETL
 *
 * Creates a workflow for remote integrations or triggers local ETL for LocalTransform integrations
 */
export const createWorkflowOrLocalAction = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateWorkflowOrLocalActionData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateWorkflowOrLocalActionResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/workflows",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get a workflow
 *
 * Get a workflow
 */
export const getWorkflow = <ThrowOnError extends boolean = false>(
  options: Options<GetWorkflowData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetWorkflowResponses,
    GetWorkflowErrors,
    ThrowOnError
  >({
    responseTransformer: getWorkflowResponseTransformer,
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/workflows/{id}",
    ...options,
  });

/**
 * Stream workflows by graphId using Server-Sent Events
 *
 * Streams workflows associated with a graphId using Server-Sent Events. Updates are sent when workflows change. The response is a stream of Server-Sent Events where each event's data field contains a JSON-serialized WorkflowStreamEvent.
 */
export const getWorkflowsStream = <ThrowOnError extends boolean = false>(
  options: Options<GetWorkflowsStreamData, ThrowOnError>,
) =>
  (options.client ?? client).sse.get<
    GetWorkflowsStreamResponses,
    GetWorkflowsStreamErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/workflows/{graphId}/stream",
    ...options,
  });

/**
 * Get a workflows raw data
 *
 * Get a workflows raw data
 */
export const getWorkflowRawData = <ThrowOnError extends boolean = false>(
  options: Options<GetWorkflowRawDataData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetWorkflowRawDataResponses,
    GetWorkflowRawDataErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "x-mvz-auth", type: "apiKey" },
    ],
    url: "/workflows/{id}/raw",
    ...options,
  });
